<template>
  <span
    v-b-tooltip
    :title="title"
    tabindex="0"
  >
    <b-button
      :variant="variant"
      :class="buttonClass"
      disabled
    >Delete</b-button>
  </span>
</template>

<script>
export default {
  name: 'DeleteButtonDisabled',
  props: {
    title: {
      type: String,
      default: 'Cannot be deleted',
    },
    variant: {
      type: String,
      default: 'outline-danger',
    },
    buttonClass: String,
  },
}
</script>
